import axios from 'axios';
import { getSessionServerId, getSessionToken } from '@/services/session';

const SOURCE_ID = Number(import.meta.env.VITE_SOURCE_ID || 0);
const API_BASE = String(import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '');

const api = axios.create({
  baseURL: API_BASE
});

api.interceptors.request.use((config) => {
  const token = getSessionToken();
  const institutionId = getSessionServerId();
  const currentChildUin = localStorage.getItem('currentChildUin');
  const translation = localStorage.getItem('translation');

  const nextConfig = { ...config };
  nextConfig.headers = { ...(nextConfig.headers || {}) };
  nextConfig.params = { ...(nextConfig.params || {}), source_id: SOURCE_ID };

  if (currentChildUin) {
    nextConfig.params.currentChildUin = currentChildUin;
  }

  if (token) {
    nextConfig.headers.Authorization = `Bearer ${token}`;
  }

  if (institutionId) {
    nextConfig.headers['x-server-id'] = institutionId;
  }

  if (translation === 'ru') {
    nextConfig.headers['x-lang'] = 'ru-RU';
    nextConfig.params['x-lang'] = 'ru-RU';
  } else if (translation === 'kz') {
    nextConfig.headers['x-lang'] = 'kk-KZ';
    nextConfig.params['x-lang'] = 'kk-KZ';
  }

  return nextConfig;
});

export default api;
